import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const tagSlotRecipe = defineSlotRecipe({
  slots: ['root'],
  base: {
    root: defineStyle({
      '& button': {
        paddingInline: '0 !important',
      },
    }),
  },
});

export default tagSlotRecipe;
